import { render, staticRenderFns } from "./LearnMenu.vue?vue&type=template&id=c21a29f4&"
import script from "./LearnMenu.vue?vue&type=script&lang=js&"
export * from "./LearnMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports